<template>
    <div class="hslp-upsell-pre-eula">
        <div>
            <b-row class="mb-5 mt-2">
                <b-col cols="12" class="testimonial">
                    <b-img
                        class="round-img"
                        :src="headshot.path"
                        alt="img"
                    />
                    <div class="text-info">
                        "Don't sign the contract until Sellers Shield is in place."<br/>
                        - Scott C. saved <span class="green">$19,801.00</span> by using Sellers Shield
                    </div>
                </b-col>
            </b-row>
            <b-row
                class="mb-4"
                align-h="center"
            >
                <b-col cols="10">
                    <div class="h2 text-center mb-2">
                        Get Home Sale Legal Protection™ - after the sale, it will be too late
                    </div>

                    <div class="font-size-4 text-center mb-4">
                        Provides you peace of mind from home sale legal claims for pennies of the sale.
                    </div>
                </b-col>
            </b-row>

            <div class="mb-5">
                <hslp-form-pre-eula
                    ref="HslpFormPreEula"
                    :is-public="isPublic"
                    is-upsell
                    :upsell-payment-visible="upsellPaymentVisible"
                    :order-app-resource="orderAppResource"
                    :seller-app-resource="sellerAppResource"
                    @change-payment-method="handleChangePaymentMethod"
                    @click-no-protection="clickNoProtection"
                />
            </div>

            <div v-if="selectedPaymentMethod === 'pay-now' && upsellPaymentVisible">
                <b-row
                    class="mb-3"
                    align-h="center"
                >
                    <b-col cols="4">
                        <b-button
                            variant="primary"
                            size="lg"
                            block
                            @click="addProtection"
                        >
                            <b-spinner
                                class="mr-1"
                                small
                                v-if="saving"
                            />

                            Pay now
                        </b-button>
                    </b-col>
                </b-row>

                <div class="d-flex justify-content-center">
                    <b-button
                        class="text-dark"
                        variant="tertiary"
                        size="lg"
                        @click="upsellPaymentVisible = false"
                    >
                        Cancel
                    </b-button>
                </div>
            </div>

            <div v-else-if="selectedPaymentMethod === 'pay-at-close' && upsellPaymentVisible">
                <b-row
                    class="mb-3"
                    align-h="center"
                >
                    <b-col
                        cols="12"
                        md="4"
                    >
                        <b-button
                            variant="primary"
                            size="lg"
                            block
                            @click="protectYourSale"
                        >
                            <b-spinner
                                class="mr-1"
                                small
                                v-if="saving"
                            />

                            Protect your sale
                        </b-button>
                    </b-col>
                </b-row>

                <div class="d-flex justify-content-center">
                    <b-button
                        class="text-dark"
                        variant="tertiary"
                        size="lg"
                        @click="upsellPaymentVisible = false"
                    >
                        Cancel
                    </b-button>
                </div>
            </div>

            <div class="info-tip alert alert-primary">
                <img src="@assets/images/smarty-says-mr.png" alt="info"/>
                <span>The majority of Lawsuits occur within 1 to 2 years of the home sale! </span>
            </div>

            <b-row>
                <b-col cols="12">
                    <h2 class="text-center mt-4 mb-4">Here are a few recent examples of sellers who would have saved a
                        lot with Home Sale Legal Protection™</h2>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="text-center gray-bg">
                    <b-img
                        class="img-fluid"
                        :src="img.examples"
                        alt="Recent Examples"
                    />
                </b-col>
            </b-row>

        </div>
    </div>
</template>

<script>
import './HslpUpsellPreEula.scss';
import FormErrorsMixin from '@sellers-shield-home-protection/ss-ui-kit/src/components/FormErrors/FormErrorsMixin';
import HslpFormPreEula from '@components/other/HslpForm/HslpFormPreEula';
import {pageId} from "@helpers/fromPage";
import {isAgent} from "@helpers/user";

export default {
    name: 'HslpUpsellPreEula',
    mixins: [
        FormErrorsMixin
    ],
    components: {
        HslpFormPreEula
    },
    data: () => ({
        saving: false,
        upsellPaymentVisible: false,
        selectedPaymentMethod: '',
        headshot: {
            path: require('@assets/images/headshot.png'),
        },
        img: {
            examples: require('@assets/images/socialtext.png'),
        },
    }),
    props: {
        orderAppResource: {
            type: Object,
            required: true,
        },
        sellerAppResource: {
            type: Object,
        },
        isPublic: {
            type: Boolean,
        },
    },
    methods: {
        async handleChangePaymentMethod(selectedPaymentMethod) {
            this.selectedPaymentMethod = selectedPaymentMethod;
            this.upsellPaymentVisible = true;
        },
        async protectYourSale() {
            if (this.selectedPaymentMethod === 'pay-now') {
                this.upsellPaymentVisible = true;
            } else {
                await this.addProtection();
            }
        },
        async addProtection() {
            await this.catchAppResourceErrors(async () => {
                let result = await this.$refs.HslpFormPreEula.addProtection(this.currentPageId);

                if (result) {
                    await this.$router.push({
                        name: 'dashboard',
                        params: {uuid: this.$route.params.uuid}
                    });
                }
            }, 'saving');
        },
        async clickNoProtection() {
            this.$emit('noProtection');
            await this.$router.push({name: 'dashboard', params: {uuid: this.$route.params.uuid}});
        },
    },
    computed: {
        currentPageId() {
            return pageId(this.$route.name, isAgent);
        }
    },
}
</script>

